import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

declare var window: any;

@Injectable({
    providedIn: 'root',
})
export class GoogleAdWordsService {
    setCapterraPixel() {
        if (environment.SiteId === 2) {
            const capterra_vkey = '2c0e84e60f13b0b74e6ec1c7c7e1f3f3',
                    capterra_vid = '2099397',
                    capterra_prefix = (('https:' === window.document.location.protocol)
                            ? 'https://ct.capterra.com'
                            : 'http://ct.capterra.com');

            (function () {
                const ct = window.document.createElement('script');
                ct.type = 'text/javascript';
                ct.async = true;
                ct.src = capterra_prefix + '/capterra_tracker.js?vid=' + capterra_vid + '&vkey=' + capterra_vkey;
                const s = window.document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(ct, s);
            })();
        } else {
            const capterra_vkey = '194d609f47b7a446271b2b87a16aaed9',
                    capterra_vid = '2123505',
                    capterra_prefix = (('https:' === window.document.location.protocol)
                            ? 'https://ct.capterra.com'
                            : 'http://ct.capterra.com');

            (function () {
                const ct = window.document.createElement('script');
                ct.type = 'text/javascript';
                ct.async = true;
                ct.src = capterra_prefix + '/capterra_tracker.js?vid=' + capterra_vid + '&vkey=' + capterra_vkey;
                const s = window.document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(ct, s);
            })();
        }
    }
}
